export class User {
  public id: string;
  public role: string;
  public roles: any[];
  public fullName: string;
  public language: string;
  public access: boolean;
  public testing: boolean;
  public status: string;
  public mainGroup: string;

  constructor(id: string,
              role: string,
              roles: any[],
              fName: string,
              language: string,
              access: boolean,
              testing: boolean,
              status: string,
              mainGroup: string) {
    this.id = id;
    this.role = role;
    this.roles = roles;
    this.fullName = fName;
    this.language = language;
    this.access = access;
    this.testing = testing;
    this.status = status;
    this.mainGroup = mainGroup;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/user.model.ts